<mat-card-header [ngClass]="error ? 'system-message error' : ''">
  <mat-card-title class="nsc-card-title">
    <h3>
      <ng-content></ng-content>
      @if (note) {
        <span class="nsc-card-title__note mat-caption">{{ note }}</span>
      }
    </h3>
  </mat-card-title>
  @if (helpText) {
    <div class="nsc-card-title__help">
      <button mat-icon-button aria-label="Information" id="{{id}}_helpicon" (click)="openHelpDialog()">
        <mat-icon aria-hidden="true">info</mat-icon>
      </button>
    </div>
  }
</mat-card-header>
